import { mapActions } from 'vuex'

export default {
  computed: {
    // Use these as "read-only" computed arrays
    // and do the final updates in handleDrag().
    leftColumnItems() {
      return this.contentItemsList.filter(contentItemID => {
        const item = this.widgetObject.steps[this.targetStepID].contentItems[contentItemID]
        return item?.column === 'A'
      })
    },
    rightColumnItems() {
      return this.contentItemsList.filter(contentItemID => {
        const item = this.widgetObject.steps[this.targetStepID].contentItems[contentItemID]
        return item?.column === 'B'
      })
    },
  },
  methods: {
    ...mapActions('campaign/contentItem',
      ['updateContentItem']),
    getGlobalIndex(contentItemID) {
      // returns the position in the full contentItemsList
      return this.contentItemsList.indexOf(contentItemID)
    },
    /**
     * The main method to handle re-ordering or moving items
     * from left to right or right to left. Called once after
     * the user finishes a drag in Draggable (“@change” event).
     */
    handleDrag(destinationColumn, event) {
      // Draggable passes { moved, added, removed, ... } etc.
      // If an item was moved from one column to the other, "moved" may not be present,
      // but "added" or "removed" might be. So we’ll do a short setTimeout or nextTick
      // to gather final arrays from v-model (leftColumnItems / rightColumnItems).
      this.$nextTick(() => {
        // 1) We'll gather up the final arrays as decided by Draggable
        const left = JSON.parse(JSON.stringify(this.leftColumnItems))
        const right = JSON.parse(JSON.stringify(this.rightColumnItems))

        if (event.added?.element && typeof event.added?.element !== 'object') {
          // Added from one column to another
          const newElement = JSON.parse(JSON.stringify(
            this.widgetObject.steps[this.targetStepID].contentItems[event.added?.element]))
          newElement.column = destinationColumn

          if (destinationColumn === 'A') {
            // Find the index of the ID in the leftColumnItems
            const index = left.findIndex(
              item => item === event.added?.element)
            if (index !== -1) {
              // Replace the ID with the cloned object
              left.splice(index, 1, newElement)
            }
          } else if (destinationColumn === 'B') {
            // Find the index of the ID in the rightColumnItems
            const index = right.findIndex(
              item => item === event.added?.element)
            if (index !== -1) {
              // Replace the ID with the cloned object
              right.splice(index, 1, newElement)
            }
          }
        }
        // 2) Update each item’s .column property in our widgetObject,
        //    so we know which column they are in now.
        left.forEach(item => {
          if (typeof item === 'object') {
            // item is a plain object => update its .column property
            item.column = 'A'
          }
        })

        right.forEach(item => {
          if (typeof item === 'object') {
            item.column = 'B'
          }
        })

        // 3) Combine them into a final array with no duplicates
        const finalList = [...left, ...right]
        const uniqueFinalList = Array.from(new Set(finalList))

        // 4) Assign to contentItemsList once
        this.contentItemsList = uniqueFinalList
      })
    },
  },
}
